import { Component, ElementRef, OnInit, OnDestroy, ViewChild, ViewContainerRef } from '@angular/core';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
declare var require: any;
import * as Globals from '../globals';
import * as IDMap from '../idmap';
import { Http, Response } from '@angular/http';
import { HeaderService } from '../header.service';
import { ProfileService } from '../profile.service';
import { ActivatedRoute, Router, RoutesRecognized } from '@angular/router';
import {SimpleTimer} from 'ng2-simple-timer';
const Highcharts = require('highcharts');
const Highmaps = require('highcharts/highmaps.src');
import 'highcharts/adapters/standalone-framework.src';
//import 'highcharts/modules/map.src';
//import 'js/highcharts/highcharts-more.src.js';
declare var $: any;
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  @ViewChild('chart') public chartEl: ElementRef;
  @ViewChild('piechart') public piechartEl: ElementRef;
  dailyBids: any[];
  agentBids: any[];
  agentTarget: any[];
  amtBids: number = 0;
  amtPendings: number = 0;
  targetmitdis: number = 0;
  lblAmtBids: string = '0';
  lblAmtPending: string = '0';
  lblAmtPriority: string = '0';
  lblAmtNonPriority: string = '0';
  xDailyBids: any[];
  dataDailyBids: any[];
  dataDailyBidsConfirm: any[];
  dataDailyBids2: any[];
  dataMap: any[];
  dataRegion: any[];
  profesi: any[];
  sortAsc: boolean = false;
  p: number = 1;
  p2: number = 1;
  colSort: string[] = ['-AMT_BID'];
  col: number = 2;
  userProfile: any;
  loading: boolean;
  series: any[];
  selectedSeries: any;
  selectedAucType: any;
  auctionTypes: any[];
  selectedAucName: any;
  aucId: any;
  idx: number = 0;
  constructor(private http: Http, public toastr: ToastsManager, vRef: ViewContainerRef, private headerService: HeaderService, private profileService: ProfileService, private router: Router, private st: SimpleTimer) {
    this.userProfile = { MAIN_MENU: [], CONTROL_PANEL: [], FULLNAME: '' };
    this.toastr.setRootViewContainerRef(vRef);
    this.auctionTypes = [{ aucType: 1, name: 'Penerbitan' }, { aucType: 2, name: 'Redemption' }];
    // this.st.newTimer('1min', 60);
    // this.st.subscribe('1min', () => this.ngOnInit());
  }
  private _chart: any;
  private _piechart: any;
  ngOnInit() {
    this.series = [];
    this.dailyBids = [];
    this.xDailyBids = [];
    this.dataDailyBids = [];
    this.dataDailyBids2 = [];
    this.dataRegion = [];
    this.agentBids = [];
    this.aucId = [];
    this.dataRegion = [{ hc_key: '1', name: 'DKI Jakarta', value: 0, pcent: '0%' }, { hc_key: '2', name: 'Indonesia Barat (selain DKI Jakarta)', value: 0, pcent: '0%' }, { hc_key: '3', name: 'Indonesia Tengah', value: 0, pcent: '0%' }, { hc_key: '4', name: 'Indonesia Timur', value: 0, pcent: '0%' }];
    this.selectedSeries = { SERIES_ID: 0, SERIES_NAME: '' };
    this.selectedAucType = this.auctionTypes[0];
    if (!this.profileService.userProfile) {
        this.profileService.signOut();
    } else {
        this.userProfile = this.profileService.userProfile;
        if (this.userProfile.PARENT_GROUP_ID == 9) {
          this.router.navigate(['/download/1']);
        }
        else {
          this.getAuction();
          // this.getSeries();
        }
    }
  }
  ngOnDestroy() {
    //if (this.series.length > 0) {
    //    this._chart.destroy();
    //    this._piechart.destroy();
    //}
  }
  setAucType() {
    if (this.selectedAucType.aucType == 2) {
      this.selectedAucType = this.auctionTypes[0];
    } else {
      this.selectedAucType = this.auctionTypes[1];
    }
    this.loading = true;
    this.getMapData();
    this.setLblAmt();
  }
  setChart() {
    let opts: any = {
      title: {
        text: '',
        x: -20
      },
      xAxis: {
        categories: this.xDailyBids
      },
      yAxis: {
        //labels: {
        //    style: {
        //        color: '#ffffff'
        //    }
        //},
        title: {
          text: 'Dalam Juta Rupiah'
        }
      },
      credits: { enabled: false },
      series: [{
        type: 'column',
        color: '#7266BA',
        name: 'Bids Harian (Pending)',
        data: this.dataDailyBids
      },
      {
        type: 'column',
        color: '#84b758',
        name: 'Bids Harian (Confirm)',
        data: this.dataDailyBidsConfirm
      },
      {
        type: 'spline',
        color: '#48D1CC',
        name: 'Total Bids (Confirm)',
        data: this.dataDailyBids2
      }]
    };

    if (this.chartEl && this.chartEl.nativeElement) {
      opts.chart = {
        type: 'line',
        renderTo: this.chartEl.nativeElement,
        backgroundColor: 'rgba(0,0,0,0)'
      };

      this._chart = new Highcharts.Chart(opts);
    }
  }
  setPieChart() {
    let opts: any = {
      title: {
        text: ''
      },
      colors: ['#4472c4', '#AA4643', '#89A54E', '#80699B', '#3D96AE', '#DB843D', '#92A8CD', '#A47D7C', '#B5CA92'],
      tooltip: {
        pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: false
          },
          showInLegend: true
        }
      },
      credits: { enabled: false },
      legend: {
        layout: 'vertical',
        align: 'right',
        verticalAlign: 'middle',
        floating: false
      },
      series: [{
        name: 'Pekerjaan',
        colorByPoint: true,
        data: this.profesi
      }]
    }
    if (this.piechartEl && this.piechartEl.nativeElement) {
      opts.chart = {
        plotBackgroundColor: null,
        backgroundColor: 'rgba(0,0,0,0)',
        plotBorderWidth: null,
        plotShadow: false,
        renderTo: this.piechartEl.nativeElement,
        type: 'pie'
      };

      this._piechart = new Highcharts.Chart(opts);
    }
  }
  getDailyBids() {
    this.http.get(Globals.serviceUrl + 'ritel/dashDailyBids?seriesId=' + this.selectedSeries.SERIES_ID + '&aucType=' + this.selectedAucType.aucType + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.dailyBids = res.json();
        this.xDailyBids = [];
        this.dataDailyBids = [];
        this.dataDailyBidsConfirm = [];
        this.dataDailyBids2 = [];
        var progress: number = 0;
        for (var i = 0; i < this.dailyBids.length; i++) {
          if (this.dailyBids[i].AMT == null){
            this.dailyBids[i].AMT = 0;
          }
          if (this.dailyBids[i].AMT_PENDING == null){
            this.dailyBids[i].AMT_PENDING = 0;
          }
          if (this.dailyBids[i].AMT + this.dailyBids[i].AMT_PENDING>0) {
            progress += this.dailyBids[i].AMT / 1000000;
            this.dataDailyBids.push(this.dailyBids[i].AMT_PENDING / 1000000);
            this.dataDailyBidsConfirm.push(this.dailyBids[i].AMT / 1000000);
            this.dataDailyBids2.push(progress);
          }
          this.xDailyBids.push(this.dailyBids[i].BID_DATE_NAME);
        }
        if (this.series.length > 0) {
          this.setChart();
          this.getProfesiBids();
        }
        if (!this.userProfile.PA_ID) {
          this.getAgentBids();
        }

      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }
  getAgentBids() {
    this.http.get(Globals.serviceUrl + 'ritel/dashAgentBids?seriesId=' + this.selectedSeries.SERIES_ID + '&aucType=' + this.selectedAucType.aucType + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.amtBids = 0;
        this.amtPendings = 0;
        this.targetmitdis = 0;
        this.agentBids = res.json();
        this.agentTarget = res.json();
        for (var i = 0; i < this.agentBids.length; i++) {
          if (this.agentBids[i].AMT_BID > 0) {
            this.amtBids += this.agentBids[i].AMT_BID;
          }
          this.targetmitdis += this.agentBids[i].TARGET
          if (this.agentBids[i].AMT_PENDING > 0) {
            this.amtPendings += this.agentBids[i].AMT_PENDING;
          }
        }
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }
  getProfesiBids() {
    this.http.get(Globals.serviceUrl + 'ritel/dashprofesi?seriesId=' + this.selectedSeries.SERIES_ID + '&aucType=' + this.selectedAucType.aucType + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.profesi = [];
        var data = res.json();
        for (var i = 0; i < data.length; i++) {
          if (i == 1) {
            this.profesi.push({ name: data[i].PROFESI_NAME, y: data[i].AMT, sliced: true, selected: true });
          } else {
            this.profesi.push({ name: data[i].PROFESI_NAME, y: data[i].AMT });
          }

        }
        this.setPieChart();
        this.getRegionData();
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }
  setAuction(e, f) {
    this.selectedAucName = e;
    this.selectedAucType.aucType = f;
    this.getSeries();
  }
  getAuction() {
    this.loading = true;
    this.http.get(Globals.serviceUrl + 'ritel/aucOffline?&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.aucId = res.json();
        if (this.aucId.length > 0) {
          this.selectedAucName = this.aucId[0].AUCTION_NAME;
          this.selectedAucType.aucType = this.aucId[0].CD_AUCTION_TYPE;
          this.getSeries();
        }
        else {
          this.loading = false;
        }
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }
  getSeries() {
    this.loading = true;
    this.http.get(Globals.serviceUrl + 'ritel/dashSeries?aucName=' + this.selectedAucName + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.series = res.json();
        if (this.series.length > 0) {
          this.selectedSeries = this.series[0];
          this.selectedAucType = this.auctionTypes[0];
          // if (this.selectedSeries.CD_AUCTION_TYPE == '2') {
          //   this.selectedAucType = this.auctionTypes[1];
          // }
          this.idx = 0;
          this.getMapData();
          this.setLblAmt();
        } else {
          //this.toastr.warning('Sesi penawaran telah selesai');
          this.loading = false;
        }

      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }
  setSeries(series) {
    this.selectedSeries = series;
    if (this.series.length > 1) {
      this.idx++;
      if (this.series.length == this.idx) {
        this.idx = 0;
      }
      this.selectedSeries = this.series[this.idx];
      if (this.selectedSeries.CD_AUCTION_TYPE == '1') {
        this.selectedAucType = this.auctionTypes[0];
      } else {
        this.selectedAucType = this.auctionTypes[1];
      }
      this.loading = true;
      this.getMapData();
      this.setLblAmt();
    }
  }
  setLblAmt() {
    if (this.selectedAucType.aucType == 1) {
      this.lblAmtBids = this.getLblNumber(this.selectedSeries.ISSUE_AMT_REAL);
      this.lblAmtPending = this.getLblNumber(this.selectedSeries.ISSUE_AMT_PENDING);
      this.lblAmtPriority = this.getLblNumber(this.selectedSeries.ISSUE_AMT_PRIORITY);
      this.lblAmtNonPriority = this.getLblNumber(this.selectedSeries.ISSUE_AMT_NON_PRIORITY);
    } else {
      this.lblAmtBids = this.getLblNumber(this.selectedSeries.AMT_REAL);
      this.lblAmtPending = this.getLblNumber(this.selectedSeries.AMT_PENDING);
    }

  }
  getLblNumber(val: number) {
    if (val < 1000000000000 && val >= 1000000000) {
      return Math.round(val / 1000000) / 1000 + ' M';
    }
    else if (val < 1000000000 && val >= 1000000) {
      return Math.round(val / 1000) / 1000 + ' Jt';
    } else {
      return Math.round(val / 1000000000) / 1000 + ' T';
    }
  }
  getMapData() {
    this.http.get(Globals.serviceUrl + 'ritel/dashmap?seriesId=' + this.selectedSeries.SERIES_ID + '&aucType=' + this.selectedAucType.aucType + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.dataMap = res.json();
        this.setMap();
        this.getDailyBids();
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }
  getRegionData() {
    this.http.get(Globals.serviceUrl + 'ritel/dashregion?seriesId=' + this.selectedSeries.SERIES_ID + '&aucType=' + this.selectedAucType.aucType + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.dataRegion = res.json();
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }
  setMap() {
    $('#map').highcharts('Map', {

      title: {
        text: 'Sebaran Data Kepemilikan ' + this.selectedSeries.SERIES_NAME
      },

      subtitle: {
        text: ''
      },
      credits: {
        enabled: false
      },
      mapNavigation: {
        enabled: false,
        buttonOptions: {
          verticalAlign: 'bottom'
        }
      },

      colorAxis: {
        dataClasses: [{
          from: 5000000,
          color: "#FFEFBF"
        }, {
          from: 10000000000,
          color: "#FFDF80"
        }, {
          from: 50000000000,
          color: "#FFC720"
        }, {
          from: 100000000000,
          color: "#f39c12"
        }, {
          from: 500000000000,
          color: "#CA5900"
        }, {
          from: 1000000000000,
          color: "#652D00"
        }]
      },
      legend: {
        align: 'left',
        valueDecimals: 0,
        //verticalAlign: 'bottom',
        floating: true,
        layout: 'vertical'
        //valueDecimals: 0,
        ////backgroundColor: (Highcharts.theme && Highcharts.theme.legendBackgroundColor) || 'rgba(255, 255, 255, 0.85)',
        //symbolRadius: 0,
        //symbolHeight: 14
      },
      series: [{
        data: this.dataMap,
        mapData: IDMap.idmap,
        joinBy: 'hc_key',
        name: 'Nominal',
        states: {
          hover: {
            color: '#F05050'
          }
        },
        dataLabels: {
          enabled: true,
          format: '{point.name}'
        }
      }]
    });
  }

}



// WEBPACK FOOTER //
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/app/dashboard/dashboard.component.ts